import { baseApi } from './baseApi'

export const storesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getStores: builder.query({
            query: (params) => ({
                url: '/stores',
                params
            }),
            providesTags: (result) =>
                result?.items
                    ? [
                        ...result.items.map((s) => ({ type: 'Stores', id: s.tid })),
                        { type: 'Stores', id: 'LIST' }
                    ]
                    : [{ type: 'Stores', id: 'LIST' }]
        }),
        getStoresTree: builder.query({
            query: () => ({
                url: '/stores',
                params: { mode: 'tree' }
            }),
            providesTags: [{ type: 'Stores', id: 'TREE' }]
        }),
        getRegionsTree: builder.query({
            query: () => ({
                url: '/stores',
                params: { mode: 'tree', levels: 'area,name' }
            }),
            providesTags: [{ type: 'Stores', id: 'REGIONS_TREE' }]
        }),
        getRegionsTreeByLevels: builder.query({
            query: (levels) => ({
                url: '/stores',
                params: { mode: 'tree', levels }
            }),
            providesTags: (_, __, levels) => [{ type: 'Stores', id: `TREE_${levels}` }]
        }),
        getStore: builder.query({
            query: (storeId) => ({ url: `/stores/${storeId}` }),
            providesTags: (_r, _e, storeId) => [{ type: 'Stores', id: storeId }]
        }),
        createStore: builder.mutation({
            query: (body) => ({
                url: '/stores',
                method: 'POST',
                body
            }),
            invalidatesTags: [
                { type: 'Stores', id: 'LIST' },
                { type: 'Stores', id: 'TREE' }
            ]
        }),
        updateStore: builder.mutation({
            query: ({ storeId, body }) => ({
                url: `/stores/${storeId}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: (_r, _e, { storeId }) => [
                { type: 'Stores', id: 'LIST' },
                { type: 'Stores', id: 'TREE' },
                { type: 'Stores', id: storeId }
            ]
        }),
        deleteStores: builder.mutation({
            query: (storeIds) => ({
                url: `/stores/${Array.isArray(storeIds) ? storeIds.join(',') : storeIds}`,
                method: 'DELETE'
            }),
            invalidatesTags: [
                { type: 'Stores', id: 'LIST' },
                { type: 'Stores', id: 'TREE' }
            ]
        }),
        uploadStoreImage: builder.mutation({
            query: ({ storeId, file }) => {
                const formData = new FormData()
                formData.append('image', file)
                return {
                    url: `/stores/${storeId}/image`,
                    method: 'POST',
                    body: formData
                }
            },
            invalidatesTags: (_r, _e, { storeId }) => [
                { type: 'Stores', id: 'LIST' },
                { type: 'Stores', id: storeId }
            ]
        }),
        deleteStoreImage: builder.mutation({
            query: (storeId) => ({
                url: `/stores/${storeId}/image`,
                method: 'DELETE'
            }),
            invalidatesTags: (_r, _e, storeId) => [
                { type: 'Stores', id: 'LIST' },
                { type: 'Stores', id: storeId }
            ]
        })
    })
})

export const {
    useGetStoresQuery,
    useGetStoresTreeQuery,
    useGetRegionsTreeQuery,
    useGetRegionsSensorTreeQuery,
    useGetRegionsTreeByLevelsQuery,
    useGetStoreQuery,
    useCreateStoreMutation,
    useUpdateStoreMutation,
    useDeleteStoresMutation,
    useUploadStoreImageMutation,
    useDeleteStoreImageMutation
} = storesApi
